import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "../../../components/ui-components/Toast";
import {
  fetchUseCasePortfolio,
  fetchUseCase,
  saveUseCaseProfile,
} from "../api";

export const useCaseKeys = {
  portfolio: (opts) => ["useCases", "portfolio", opts?.from ?? null, opts?.to ?? null],
  detail: (nodeId, opts) => ["useCases", "detail", String(nodeId), opts?.from ?? null, opts?.to ?? null],
};

export function useUseCasePortfolioQuery(opts = {}) {
  return useQuery({
    queryKey: useCaseKeys.portfolio(opts),
    queryFn: () => fetchUseCasePortfolio(opts),
  });
}

export function useUseCaseQuery(nodeId, opts = {}) {
  return useQuery({
    queryKey: useCaseKeys.detail(nodeId, opts),
    queryFn: () => fetchUseCase(nodeId, opts),
    enabled: nodeId != null && nodeId !== "",
  });
}

export function useSaveUseCaseProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ nodeId, payload }) => saveUseCaseProfile(nodeId, payload),
    onSuccess: () => {
      // Both the portfolio and the detail page show owner and stage, so refresh
      // every use-case query rather than one key.
      queryClient.invalidateQueries({ queryKey: ["useCases"] });
      toast.success("Use case updated");
    },
    onError: (err) => {
      toast.error(err?.message || "Could not save the use case");
    },
  });
}
